




























































import { defineComponent } from '@vue/composition-api';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import PublicAuthPage from '@front-app/components/layouts/PublicAuthPage.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size } from '@front-app/components/constants';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { Routes } from '@front-app/constants/routes';

export default defineComponent({
	components: {
		PublicAuthPage,
		ColumnContainer,
		PaddedContent,
		CtaButton,
	},
	setup() {
		const { isLoggedIn } = CurrentUserStore;
		return {
			isLoggedIn,
			toGroups: { name: Routes.GROUPS },
			toHome: { name: Routes.HOME },
			// Util
			ButtonPalettes,
			Size,
		};
	},
});
